export const INSTAGRAM_LINK = 'https://www.instagram.com/mediitjamnagar/'

export const FACEBOOK_LINK =  'https://www.facebook.com/people/Mediit-Jamnagar/100082142253841/?mibextid=LQQJ4d'

export const YOUTUBE_LINK = 'https://www.youtube.com/@mediitjamnagar6054'

export const TWITTER_LINK = 'https://twitter.com/MediitJamnagar'

export const LINKEDIN_LINK = 'https://www.linkedin.com/in/mediit-jamnagar-06188319b'